<div
	[ngClass]="{
		'md:grid-cols-2': grid() === 'cols-2',
		'md:grid-cols-3': grid() === 'cols-3',
	}"
	class="grid grid-cols-1 gap-1"
	data-test-id="selection-card"
>
	@for (option of options(); track option.inputId) {
		<vp-selection-card-input
			[controlType]="cardControlType"
			[hasCardsAsMarkdown]="hasCardsAsMarkdown()"
			[hasError]="hasError()"
			[isDisabled]="isDisabled()"
			[isReadonly]="isReadonly()"
			[isSelected]="option.selected"
			[name]="name()"
			[option]="option"
			(changed)="updateOptions($event)"
		/>
	}
</div>
